import {
  FETCH_LOADING,
  GET_INVITED_NUMBERS,
  POPUP_LOADING,
  SET_ACTIVE_STEP,
  SET_POPUP_STATUS,
  FETCH_ERROR,
  SET_NEW_LIMITS, CHANGE_INVITE_ITEMS, CHANGE_PROCESSING_STATUS, SET_PRICE_AFTER_DELETE_NUMBER,
} from './constants';
import { LIMITS_IN_PROCESSING_TEXT } from '../constants';

const initialState = {
  isLoading: true,
  isError: false,
  invites: [],
  count: 0,
  discount: null,
  price: '',
  unit: '₽/мес',
  content: {
    sebInviteDescription: '',
    sdbInviteDescription: '',
    serviceTexts: {},
    ctnSetupTexts: {},
    popups: {},
  },
  popupRequestStatus: {
    error: {},
    isLoading: false,
  },
  familyPopups: {
    isOpen: false,
    step: '',
  },
  newLimits: {},
};

export default function family(state = initialState, action) {
  switch (action.type) {
    case FETCH_ERROR:
      return { ...state, isError: action.payload };
    case FETCH_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_POPUP_STATUS:
      return { ...state, familyPopups: { ...state.familyPopups, isOpen: action.payload } };
    case SET_ACTIVE_STEP:
      return { ...state, familyPopups: { ...state.familyPopups, step: action.payload } };
    case SET_NEW_LIMITS:
      return { ...state, newLimits: action.payload };
    case POPUP_LOADING:
      return { ...state,
        popupRequestStatus: {
          ...state.popupRequestStatus,
          isLoading: action.payload,
        } };
    case GET_INVITED_NUMBERS:
      return { ...state, ...action.payload };
    case CHANGE_INVITE_ITEMS:
      // eslint-disable-next-line no-case-declarations
      const filteredInvites = state.invites.filter((invite) => invite.ctn !== action.payload);
      return { ...state, invites: filteredInvites };
    case CHANGE_PROCESSING_STATUS:
      // eslint-disable-next-line no-case-declarations
      const inviteInProcess = state.invites.map((invite) => (invite.ctn === action.payload
        ? { ...invite, isProcessing: true, limitAccessStatusText: LIMITS_IN_PROCESSING_TEXT } : invite));
      return { ...state, invites: inviteInProcess };
    case SET_PRICE_AFTER_DELETE_NUMBER:
      return { ...state, familyPopups: { ...state.familyPopups, priceAfterDeleteNumberInfo: action.payload } };
    default:
      return state;
  }
}
